import { create } from 'zustand';

export interface Toast {
  id: number;
  kind: 'info' | 'success' | 'error';
  text: string;
}

interface UiState {
  toasts: Toast[];
  toast(text: string, kind?: Toast['kind'], ms?: number): void;
  dismiss(id: number): void;
  sheet: string | null;
  openSheet(name: string | null): void;
}

let seq = 0;

export const useUi = create<UiState>((set, get) => ({
  toasts: [],
  toast(text, kind = 'info', ms = 3200) {
    const id = ++seq;
    set({ toasts: [...get().toasts.slice(-2), { id, kind, text }] });
    setTimeout(() => get().dismiss(id), ms);
  },
  dismiss(id) {
    set({ toasts: get().toasts.filter((t) => t.id !== id) });
  },
  sheet: null,
  openSheet(name) {
    set({ sheet: name });
  },
}));

export const toast = (text: string, kind: Toast['kind'] = 'info') => useUi.getState().toast(text, kind);
